import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ViewStyle } from 'react-native';
import { useMarketplaceColors } from '@/constants/residents/marketplaceColors';

interface ToggleOption {
  key: string;
  label: string;
}

interface ToggleBarProps {
  options: ToggleOption[];
  activeKey: string;
  onSelect: (key: string) => void;
  maxWidth?: number;
  containerStyle?: ViewStyle;
}

export const ToggleBar: React.FC<ToggleBarProps> = ({
  options,
  activeKey,
  onSelect,
  maxWidth,
  containerStyle,
}) => {
  const mc = useMarketplaceColors();

  const styles = useMemo(() => StyleSheet.create({
    container: { flexDirection: 'row', backgroundColor: mc.toggleBackground, borderRadius: 8, padding: 2 },
    option: { flex: 1, height: 30, borderRadius: 6, alignItems: 'center', justifyContent: 'center' },
    optionActive: { backgroundColor: mc.toggleActiveBackground },
    optionText: { fontSize: 12, fontWeight: '500', color: mc.textSecondary, lineHeight: 18 },
    optionTextActive: { color: mc.textPrimary },
  }), [mc]);

  return (
    <View style={[styles.container, maxWidth ? { maxWidth } : undefined, containerStyle]}>
      {options.map((option) => {
        const isActive = option.key === activeKey;
        return (
          <TouchableOpacity
            key={option.key}
            style={[styles.option, isActive && styles.optionActive]}
            onPress={() => onSelect(option.key)}
            activeOpacity={0.7}
          >
            <Text style={[styles.optionText, isActive && styles.optionTextActive]}>{option.label}</Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};
